import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { findIndex } from 'lodash-es';

import * as fromMapActions from '../../../store/actions/map.actions';
import * as fromMapSelectors from '../../../store/selectors/map.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-map-default-options',
  standalone: false,
  templateUrl: './map-default-options.component.html'
})
export class MapDefaultOptionsComponent {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private store = inject(Store);

  mapTypeIds: google.maps.MapTypeId[] = [];
  selectedMapTypeId: google.maps.MapTypeId | null = null;

  constructor() {
    this.store.pipe(select(fromMapSelectors.selectAvailableTypes)).subscribe((mapTypeIds) => {
      this.mapTypeIds = mapTypeIds;
      this.changeDetectorRef.markForCheck();
    });

    this.store.pipe(select(fromMapSelectors.selectCurrentType)).subscribe((selectedMapTypeId) => {
      this.selectedMapTypeId = selectedMapTypeId;
      this.changeDetectorRef.markForCheck();
    });
  }

  toggleMapType() {
    let index = findIndex(this.mapTypeIds, (mapType) => mapType === this.selectedMapTypeId);
    if (index + 1 >= this.mapTypeIds.length) {
      index = -1;
    }
    this.selectedMapTypeId = this.mapTypeIds[index + 1];
    this.store.dispatch(fromMapActions.updateCurrentMapType({ payload: { mapTypeId: this.selectedMapTypeId } }));
  }
}
